import { take } from 'rxjs/operators';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CompanyService } from 'src/app/domains/companies/services';
import { Company } from 'src/app/domains/companies/models';

@Component({
  selector: 'gdp-company-main',
  templateUrl: './company-main.component.html',
  styleUrls: ['./company-main.component.scss']
})
export class CompanyMainComponent implements OnInit {
  company: Company | null;
  active: string;
  currentTab = 'overview';
  public error = false;
  public TABS = [
    'overview',
    'users',
    // legacy sections hidden
    // 'fax',
    'dids',
    'sms',
    'trial-kit',
    'queues',
    'equipment',
    "integrations",
    'connectivity',
    'reviews',
    'support-devices'
  ];
  public TAB_ICONS = {
    'overview': 'icon-small-info',
    'users': 'icon-big-user',
    // legacy sections hidden
    // 'fax': 'icon-small-fax',
    'dids': 'icon-small-telephone',
    'sms': 'icon-small-mobile',
    'trial-kit': 'icon-small-delivery',
    'queues': 'icon-big-porting',
    'equipment': 'icon-big-phone',
    'integrations': 'icon-big-integrations',
    'connectivity': 'icon-small-vox-wi-fi',
    'reviews': 'icon-small-star',
    'support-devices': 'icon-small-support'
  }
  constructor(
    private companyService: CompanyService,
    public route: ActivatedRoute,
    private router: Router,
    private config: NgbDropdownConfig
  ) {
    config.placement = 'bottom';
    config.autoClose = true;
  }

  ngOnInit() {
    this.currentTab = this.route.snapshot.url[1].path;
    if (this.company == undefined) {
      const id = this.route.snapshot.params.id;
      this.fetchCompany(id);
    }
  }

  onNavChange(c: NgbNavChangeEvent) {
    this.currentTab = c.nextId;
  }

  private fetchCompany(id: number) {
    this.error = false;
    this.companyService.getCompany(id).pipe(take(1)).subscribe({
      next: (company: Company) => {
        this.company = company;
      },
      error: () => {
        this.company = null;
        this.error = true;
      }
    });
  }

  public switchTab(tabId: string): void {
    this.router.navigate([
      `/dashboard/companies/${this.route.snapshot.params.id}/${tabId}`
    ]);
  }

}
